import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDividerModule } from '@angular/material/divider';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

import { StateManagerProjectService } from '@state-manager';
import { SharedModule } from '@shared/shared.module';
import { ToolbarModule } from '@shared/toolbar/toolbar.module';
import { ViewerModule } from '@viewer/viewer.module';
import { MRIEditerComponent } from './MRIEditer.component';
import { MRIEditerRoutingModule } from './MRIEditer.routing.module';
import { MRIEditerResolver } from './MRIEditer.resolver';
import { ViewerRightPanelModule } from '../viewer-right-panel/viewer-right-panel.module';
import { CornerstoneService } from '../viewer/cornerstone.service';
import { KeyInteractionService } from '../interaction';
import { ErrorInterceptor } from '../interceptors/error.interceptor';
import { InfoPanelAboutClaimantUserComponent } from './info-panel-about-claimant-user/info-panel-about-claimant-user.component';
import { ExitGuard } from '../shared/guards/exit-guard.service';

@NgModule({
  imports: [
    CommonModule,
    MRIEditerRoutingModule,
    ViewerRightPanelModule,
    SharedModule,
    ViewerModule,
    MatSnackBarModule,
    ToolbarModule,
    MatDividerModule,
    TranslateModule,
    MatIconModule,
  ],
  declarations: [MRIEditerComponent, InfoPanelAboutClaimantUserComponent],
  providers: [
    CornerstoneService,
    StateManagerProjectService,
    KeyInteractionService,
    MRIEditerResolver,
    ExitGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
  ],
})
export class MRIEditerModule {}
